import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import BusinessProfileForm from './BusinessProfileForm'; 
import { logout } from '../../redux/actions/authActions';

const PropertyHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/thinkproperty");
  };

  return (
    <div className="font-sans text-gray-800 bg-gray-100">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-white shadow-md sticky top-0 z-50">
        <div className="text-3xl font-extrabold text-blue-700 tracking-wide">ThinkProperty</div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 font-medium text-gray-700">
          <a href="#newlaunch" className="text-blue-600 hover:text-blue-800 transition">New Launch</a>
          <a href="#deals" className="text-blue-600 hover:text-blue-800 transition">Top Properties</a>
          <a href="#whyus" className="text-blue-600 hover:text-blue-800 transition">Why Us</a>
          <a href="#business" className="text-blue-600 hover:text-blue-800 transition">Property Consultants</a>
          <a href="#business" className="text-blue-600 hover:text-blue-800 transition">Owners</a>
          <a href="#amazing" className="text-blue-600 hover:text-blue-800 transition">Amazing!!</a>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-gray-700 font-medium">Welcome, {userName}</span>
              <button
                onClick={() => navigate(`/propertydashboard`)}
                className="w-9 h-9 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                title="Dashboard"
              >
                🏠
              </button>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-full hover:bg-blue-50 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-center w-24">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-3xl text-blue-600 focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white px-6 py-4 space-y-1 text-center shadow-md">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-gray-800">
              <p className="text-green-600 font-medium">Welcome, {userName}</p>
              <div className="flex space-x-4 mt-2">
                <button
                  onClick={() => navigate(`/propertydashboard`)}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                >
                  🏠
                </button>
                <button
                  onClick={handleLogout}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                >
                  ⏻
                </button>
              </div>
            </div>
          )}
          <a href="#newlaunch" className="block hover:text-blue-600">New Launch</a>
          <a href="#deals" className="block hover:text-blue-600">Top Properties</a>
          <a href="#whyus" className="block hover:text-blue-600">Why Us</a>
          <a href="#business" className="block hover:text-blue-600">Property Consultants</a>
          <a href="#business" className="block hover:text-blue-600">Owners</a>

          <a href="#amazing" className="block hover:text-blue-600">Amazing!!</a>

          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-full hover:bg-blue-50 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-blue-600 text-white rounded-full hover:bg-blue-700 transition">Register</button>
            </div>
          )}
        </div>
      )}

      {/* Hero Section */}
      <section
        className="relative h-[75vh] sm:h-[85vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/assets/banners/thinkproperty.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 text-center px-4 sm:px-6 max-w-2xl">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 leading-tight">
            Find Your Dream Property
          </h1>
          <p className="text-lg mb-6 font-light">Buy · Sell · Rent · Invest . Secure Sharing of Photgraphs & Documents . AI Powered</p>
          <button
            onClick={() => navigate('/property-catalogue')}
            className="px-6 py-3 text-lg font-semibold bg-green-600 rounded-full hover:bg-green-700 transition"
          >
            Browse Properties
          </button>
        </div>
      </section>

      {/* Top Properties Section */}
      <section id="deals" className="py-16 px-6 md:px-20 bg-gray-100">
        <h2 className="text-3xl font-bold text-center mb-10 text-blue-700">Featured Listings</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              id: 1,
              title: "Modern 3BHK Apartment - Mumbai",
              description: "₹1.2 Cr · Near Metro · Gym + Pool"
            },
            {
              id: 2,
              title: "Luxury Villa - Pune",
              description: "₹3.5 Cr · Private Garden · Gated Society"
            },
            {
              id: 3,
              title: "Affordable 2BHK - Navi Mumbai",
              description: "₹75 Lakh · Great Connectivity · Loan Approved"
            }
          ].map((property) => (
            <div key={property.id} className="bg-white shadow-md hover:shadow-xl transition rounded-xl overflow-hidden">
              <img 
                src={`/api/downloads/thinkproperty/property/${property.id}.jpg`} 
                alt={"Property " + property.id} 
                className="w-full h-52 object-cover"
              />
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800">{property.title}</h3>
                <p className="text-gray-600 mt-2">{property.description}</p>
                <button 
                  onClick={() => navigate(`/property/${property.id}`)}
                  className="mt-4 px-5 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 text-sm transition">
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Amazing */}
      <section id="amazing" className="py-16 px-6 md:px-20 bg-gradient-to-r from-blue-600 to-green-500">
        <h2 className="text-4xl font-extrabold text-center mb-8 drop-shadow-lg">
          🌟 World’s First Property Revolution 🌍
        </h2>
        <p className="text-lg md:text-xl text-center max-w-3xl mx-auto mb-14 font-medium leading-relaxed">
          🚀 ThinkProperty is rewriting the rules of real estate!  
          <br />
          🎉 <strong>List Your Property & Earn Money</strong> 💸  
          <br />
          🔍 <strong>View Property & Earn Money</strong> 💰  
          <br />
          🏆 Be part of the biggest shift in the property world — empowering owners and seekers alike.
        </p>
      </section>

      {/* Why Choose Us */}
      <section id="whyus" className="py-16 px-6 md:px-20 bg-gradient-to-r from-blue-600 to-green-500">
        <h2 className="text-3xl font-bold text-center mb-10 text-white">Why ThinkProperty?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center text-white">
          {[
            {
              title: "Verified Listings",
              emoji: "📋",
              desc: "Every property is verified to ensure legal and structural compliance."
            },
            {
              title: "Expert Guidance",
              emoji: "🧑‍💼",
              desc: "Our agents help you through every step of your property journey."
            },
            {
              title: "Flexible Financing",
              emoji: "🏦",
              desc: "Tie-ups with top banks to help you secure your loan easily."
            },
            {
              title: "AI-Powered Support",
              emoji: "🤖",
              desc: "Instant property insights and recommendations through our AI assistant."
            },
            {
              title: "Neighbourhood Explorer",
              emoji: "🌆",
              desc: "Discover schools, hospitals, and amenities around your future property."
            },
            {
              title: "Property Videos",
              emoji: "📹",
              desc: "Watch detailed walkthroughs and aerial footage for an immersive experience."
            },
            {
              title: "Secure Media Sharing",
              emoji: "🔒",
              desc: "Upload photos & videos that can't be freely forwarded or shared on WhatsApp."
            },
            {
              title: "Document Vault",
              emoji: "📁",
              desc: "Upload and manage important documents securely for potential buyers only."
            },
            {
              title: "View Analytics",
              emoji: "👁️",
              desc: "Know who viewed your property photos or documents — stay informed."
            }
          ].map((feature, idx) => (
            <div key={idx} className="bg-white/10 p-6 rounded-lg shadow-md backdrop-blur-md hover:bg-white/20 transition">
              <div className="text-5xl mb-4">{feature.emoji}</div>
              <h4 className="text-xl font-semibold mb-2">{feature.title}</h4>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>


      {/* More Sections like Agent Join / Newsletter Signup / Testimonials can be added here */}
      {/* <NewsletterSignup /> */}
      {/* Footer */}
      <footer className="bg-blue-700 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PropertyHome;
